import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[600px] md:h-[700px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20artisan%20butter%20making%20workshop%20scene%20with%20golden%20butter%20on%20rustic%20wooden%20table%2C%20soft%20natural%20window%20light%2C%20cream%20and%20butter%20textures%2C%20vintage%20copper%20tools%2C%20warm%20amber%20and%20cream%20color%20palette%2C%20editorial%20food%20photography%20style%2C%20minimal%20composition%2C%20elegant%20artisan%20aesthetic&width=1800&height=1000&seq=hero-butter-workshop&orientation=landscape"
        alt="黄油作坊 - 手工黄油制作"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/25 to-black/55"></div>

      <div className="relative z-10 container-site text-center">
        <div className="max-w-3xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/20 mb-6">
            <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse"></span>
            <span className="text-sm text-background-50/90 font-medium">纯天然 · 零添加 · 手工精制</span>
          </div>

          <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 leading-tight mb-5">
            手工黄油的
            <span className="block text-primary-300">艺术与科学</span>
          </h1>

          <p className="text-base md:text-lg text-background-50/80 leading-relaxed max-w-xl mx-auto mb-8">
            从优质奶油的甄选，到发酵工艺的精控，再到风味配方的创意调配 ——
            黄油作坊带你走进纯天然手工黄油的世界，掌握核心技艺，创造属于你自己的风味作品。
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/shougong-huangyou-jiaocheng"
              className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 font-semibold rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              开始学习
              <i className="ri-arrow-right-line"></i>
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 px-8 py-3.5 bg-background-50/10 backdrop-blur-sm text-background-50 font-medium rounded-full border border-background-50/25 hover:bg-background-50/20 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              了解我们
              <i className="ri-information-line"></i>
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <span className="block w-6 h-10 rounded-full border-2 border-background-50/30 flex items-start justify-center p-1">
          <span className="block w-1.5 h-3 bg-background-50/50 rounded-full animate-bounce"></span>
        </span>
      </div>
    </section>
  );
}